export const MuiTab = {
  styleOverrides: {
    root: {
      '.MuiTouchRipple-root': {
        display: 'none',
      },
    },
  },
}
